import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-stack container-fluid flex-wrap px-0 mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-title d-flex flex-column justify-content-center flex-wrap me-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0" }, " Lista de estudiantes ")
], -1)
const _hoisted_3 = { class: "d-flex align-items-center gap-2 gap-lg-3" }
const _hoisted_4 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = {
  class: "text-dark-50 text-hover-primary cursor-pointer",
  style: {"line-height":"1.25"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square fs-2 text-hover-primary me-4" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-hover-danger me-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_AddEdit = _resolveComponent("AddEdit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, { type: "primary" }, {
          default: _withCtx(() => [
            _createTextVNode(" + " + _toDisplayString(_ctx.t("add")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.listStudent,
      border: "",
      "table-layout": 'auto'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "idstudent",
          label: "ID",
          width: "120",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "docnumber",
          label: "Documento",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(scope.row.docname), 1),
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(scope.row.docnumber), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Participante" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(scope.row.firstname), 1),
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(scope.row.lastname), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "sex",
          label: "Sexo",
          width: "60",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.sex == 'M')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(scope.row.sex), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row.sex), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: "Celular",
          width: "60",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "Registrado",
          width: "180",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "Opciones",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Editar",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "Eliminar",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_AddEdit)
  ], 64))
}